module.exports = __webpack_public_path__ + "img/12.e92ce2bc.png";